

export class QuantityDeviationRequest {
    grnId: number;
    farmer: number;
    indentId: number;
    grnfromDate:Date;
    grnToDate:Date;
    batchNum:string;
    harvestType?:String
    productId?:number
    // constructor(
    //     grnId: number,
    //     farmer: number,
    //     indentId: number,
    //     grnfromDate:Date,
    //     grnToDate:Date,
    //     batchNum:string
    //    ){
    //     this.grnId = grnId;
    //     this.indentId = indentId
    //     this.batchNum = batchNum
    //     this.farmer = farmer
    //     this.grnToDate = grnToDate
    //     this.grnfromDate = grnfromDate
    // }
}